// require('dotenv').config();
const API_URL = process.env.REACT_APP_API_URL;
const API_VERSION = process.env.REACT_API_VERSION;
// const API_URL = ;
const pink = '#FF8AD8';
const white = '#FFFFFF';
const red = '#E72222';
const blue = '#1313C6';
const green = '#00CE8D';
const REMBOURSEMENT_LIMIT = 6;
const DEMANDE_LIMIT = 5;
const COLOR_TABLE = [
  '#8BCAB5',
  '#F28F2F',
  '#E44856',
  '#FF8AD8',
  '#FF6722',
  '#1313C6',
  '#00CE8D',
  '#F7DA71',
  '#E72222',
  '#000000',
  '#000000'
];
const SERIES = ['seriesVisionGlobal', 'seriesPoste', 'seriesBeneficiary'];
const FAQ_URL = 'https://assistance.spvie.com/hc/fr';
const DEMANDE_COLOR = [
  {
    text: 'En cours',
    color: '#FF6722',
    status: 'undefined'
  },
  {
    text: 'En cours',
    color: '#FF6722',
    status: 'NotDone'
  },
  {
    text: 'Traité',
    color: '#00CE8D',
    status: 'WaitingLine'
  }
];
const DEMANDE_FROM = [
  {
    from: 'VOUS',
    key: 'Client',
    color: '#00CE8D'
  },
  {
    from: 'SPVIE',
    key: 'SPVIE',
    color: '#1313C6'
  }
];
const DEMANDE_HEADER = [
  {
    text: 'Date',
    sort: 'Created'
  },
  {
    text: 'Statut',
    sort: 'Status'
  },
  {
    text: 'Demande',
    sort: 'CgrmQueue'
  },
  {
    text: 'Documents',
    sort: 'Count'
  }
];

const BANETTE = {
  JUSTIFICATIF_MAINTIEN_ENFANT:'justificatif de maintien de votre enfant',
  MEDECINE_DOUCE:'médecine douce'
}


const COLOR_BUTTON = {
  SECOND_RED:"#E44856",
  ORANGE:"#F28F2F",
  SALMON:"#F4A6A0",
  BLACK:"#000000",
  GREEN:"#8BCAB5",
  BLUE:"#0D5381"
}

const SANTECLAIR_URL_DEV = 'https://services.integration.santeclair.fr/pu/mysanteclair/authentification.do?idPart=CGRM&idCharte=CGRM';
const SANTECLAIR_URL_PROD = 'https://services.santeclair.fr/pu/mysanteclair/authentification.do?idPart=CGRM&idCharte=CGRM';
const SANTECLAIR_URL = process.env.REACT_APP_ENV === 'production' ? SANTECLAIR_URL_PROD : SANTECLAIR_URL_DEV;

const COTISATION = {
  IBAN: "FR76 1670 6050 9250 0337 8301 626",
  BIC: "AGRIFRPP867",
  TITULAIRE: "S.A.R.L COURTAGE ASSUR GEST RISQUE",
}

export {
  API_URL,
  API_VERSION,
  pink,
  white,
  red,
  blue,
  green,
  REMBOURSEMENT_LIMIT,
  DEMANDE_LIMIT,
  COLOR_TABLE,
  SERIES,
  FAQ_URL,
  DEMANDE_COLOR,
  DEMANDE_FROM,
  DEMANDE_HEADER,
  COLOR_BUTTON,
  BANETTE,
  SANTECLAIR_URL,
  COTISATION,
};
